<template>
  <div></div>
</template>
<script>
export default {
  watch: {
    '$route.query.code'(a) {
      if (a) {
        this.wxlogin();
      }
    },
  },
  methods: {
    async wxlogin() {
      let e = await this.$get('/api/v1/wx_register', {
        code: this.$route.query.code,
      });
      if (e.user_id == 0) {
        this.$store.commit('user/SET_LOGINSTATE', { state: 'WX_REGISTRY' });
      } else {
        this.$store.dispatch('user/login', Object.assign({ type: 3 }, e));
      }
    },
  },
};
</script>
